module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "news",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      },
      "wheel": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.mousewheel.apply(null, arguments)
      }
    }
  }, [(!_vm.mobi) ? _c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].news))])])], 1), _c('transition', {
    attrs: {
      "name": "top-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "detail",
    on: {
      "click": function($event) {
        return _vm.openLink(_vm.newsList[0].link)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.newsList[0] && _vm.newsList[0].title))]), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.newsList[0] && _vm.newsList[0].content)
    }
  })])])], 1) : _vm._e(), _c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    staticClass: "bg pc"
  }), _c('div', {
    staticClass: "items"
  }, [_c('transition-group', {
    attrs: {
      "appear": "appear",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      style: ({
        background: ("url(" + (item.img) + ") center / auto 100%")
      }),
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          return _vm.openLink(item.link)
        }
      }
    }, [_c('div', {
      staticClass: "mask mask_1"
    }), _c('div', {
      staticClass: "mask"
    }), _c('div', {
      staticClass: "more"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].more))]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("time")(item.date)))]), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))])])])
  }), 0)], 1), _c('div', {
    staticClass: "morenews pc",
    on: {
      "click": _vm.morenews
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].moreNews))])]), (!_vm.mobi) ? _c('div', {
    staticClass: "page pc",
    style: ({
      height: _vm.height
    })
  }, [_c('div', {
    ref: "iteam",
    staticClass: "newslist",
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.moremousewheel.apply(null, arguments)
      }
    }
  }, _vm._l((_vm.oldNewsList), function(item, index) {
    return _c('div', {
      staticClass: "list",
      on: {
        "click": function($event) {
          return _vm.openLink(item.link)
        }
      }
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.img
      }
    }), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("time")(item.date)))]), _c('span', {
      staticClass: "media"
    }, [_vm._v(_vm._s(item.media))])])])
  }), 0)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b59544","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news.vue
// module id = 513
// module chunks = 1